import { createBrowserRouter } from 'react-router';
import ENV from './base/env';
import Root from './Root';

export const router = createBrowserRouter(
  [
    {
      path: '/*',
      element: <Root />,
    },
  ],
  { basename: ENV.BasePath }
);
